import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFiscalTotalAgrupadoNcm } from '@/features/relatorio/page/fiscal/total-agrupado-ncm/RelatorioFiscalTotalAgrupadoNcm';

export const Route = createFileRoute('/a/relatorio/fiscal/total-agrupado-ncm')({
    component: RelatorioFiscalTotalAgrupadoNcm,
});
